import {
  createReducer,
  defaultObjectReducer,
  defaultObjectInitialState
} from '../utils';

import {
  GET_STATIC_PAGE,
  CLEAR_STATIC_PAGE
} from '../constants/staticPage';

const initialState = defaultObjectInitialState();

const staticPage = createReducer(initialState, {
  [GET_STATIC_PAGE]: defaultObjectReducer,

  [CLEAR_STATIC_PAGE]: () => ({ ...initialState })
});

export default staticPage;



// WEBPACK FOOTER //
// ./src/reducers/staticPage.js